import React from 'react';

export default class SelectyBox extends React.Component {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
    this.populateOptions = this.populateOptions.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.updateSelecty = this.updateSelecty.bind(this);
    this.renderDefaultOption = this.renderDefaultOption.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);

    this.state = {
      options: props.options,
      value: props.options && props.options.length === 1 ? props.options[0].value : props.value,
      disabled: props.disabled ? props.disabled : [],
      loading: false,
      focused: false
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  validate() {
    let isValid = !!this.state.value && this.state.value !== '';
    return isValid ? 'valid has-data' : 'invalid';
  }

  populateOptions() {
    let options = this.state.options.map((option, index) => {
      let disabled = this.isDisabled(option.value);
      return (
        <option
          key={`${this.props.id}_${this.props.selectyName}_${index + 1}`}
          disabled={disabled}
          value={option.value}
        >
          {option.label}
        </option>
      );
    });

    return options;
  }

  isDisabled(value) {
    return this.state.disabled.indexOf(value) !== -1;
  }

  handleOnChange(e) {
    let value = e.target.value;
    this.setState({ value: value });
    this.props.onChange(value);
  }

  handleBlur() {
    this.setState({ focused: false });
  }

  handleFocus() {
    this.setState({ focused: true });
  }

  getSelectedText() {
    let selectedText = this.hasOptions() ? this.props.defaultValue : this.props.defaultValueOnEmpty;
    if (this.state.value) {
      selectedText = this.state.options.filter(option => option.value === this.state.value);
      selectedText =
        !!selectedText[0] && !!selectedText[0].label
          ? selectedText[0].label
          : this.props.defaultValue;
    }
    return selectedText;
  }

  updateSelecty() {
    if (this.props.handleCheckoutChanges) {
      this.setState({ loading: true });
      this.props.handleCheckoutChanges().then(() => {
        this.setState({ loading: false });
      });
    }
  }

  renderDefaultOption() {
    return (
      <option key={`${this.props.id}_${this.props.selectyName}_0`} value="">
        {this.props.defaultValue}
      </option>
    );
  }

  hasOptions() {
    return this.state.options && !!this.state.options.length;
  }

  renderSelect() {
    const style = {
      opacity: '0.0001',
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      width: '100%',
      height: '100%',
      top: 'auto',
      right: 'auto',
      margin: '0px',
      padding: '0px',
      border: '0px'
    };

    return (
      <select
        onChange={this.handleOnChange}
        onFocus={this.handleFocus}
        onBlur={this.handleBlur}
        data-selecty="true"
        onClick={this.updateSelecty}
        id={this.props.selectyId}
        name={this.props.selectyName}
        style={style}
        value={this.state.value}
      >
        {this.renderDefaultOption()}
        {this.populateOptions()}
      </select>
    );
  }

  render() {
    const name = `${this.props.selectyName}_${this.props.id}`;
    const classNames = `fi_sel ${this.props.classNames} ${this.validate()} ${
      this.hasOptions() ? '' : 'disabled'
    }`;
    const buttonClassNames = `selecty-button ${this.state.loading ? 'spin' : ''} ${
      this.state.focused ? 'focused' : ''
    }`;
    return (
      <div className={classNames} lang="en">
        <label htmlFor={name}>{this.props.labelText}</label>
        <span className="selecty emptyvalue selecty-empty" style={{ position: 'relative' }}>
          <span className={buttonClassNames}>
            <span>{this.getSelectedText()}</span>
          </span>
          {this.hasOptions() && this.renderSelect()}
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/selectybox.js